import { mergeStyleSets } from "@uifabric/merge-styles";

export type NewHomePageClassNames = Record<
    "root" | "content" | "header" | "submenu" | "link",
    string
>;

export function getClassNames(): NewHomePageClassNames {
    return mergeStyleSets({
        content: {
            color: "white",
            display: "flex",
            "flex-direction": "column",
            "font-family": "'Share Tech Mono', monospace"
        },
        header: {
            display: "flex",
            "justify-content": "center"
        },
        link: {
            margin: "0 10px"
        },
        root: {
            "align-items": "center",
            backgroundColor: "#101010",
            display: "flex",
            height: "100%",
            "justify-content": "center",
            width: "100%"
        },
        submenu: {
            display: "inline-flex"
        }
    });
}
